import { CSSProperties } from 'react';

export const DATASOURCE_THEMES: {
  [key: string]: CSSProperties;
} = {
  transparent: {
    backgroundColor: 'transparent',
  },
  black: {
    backgroundColor: '#4a4a4a',
    color: 'white',
    padding: '3px 5px',
    borderRadius: 5,
  },
  grey: {
    backgroundColor: '#e8e8e8',
    color: '#262626',
    padding: '3px 5px',
    borderRadius: 5,
  },
};

export type TDatasourceTheme = keyof typeof DATASOURCE_THEMES;
